export default __webpack_public_path__ + "static/media/Page3_BG2.1b788d21.png";